import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";

export default function DailyGrainCard() {
    const [data, setData] = useState({ buy: 0, sell: 0, net: 0 });

    useEffect(() => {
        const today = new Date();
        const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

        client
            .fetch(
                `*[_type == "grainTransaction" && time >= $start && time < $end]{
          buyOrSell, quantity
        }`,
                { start: startOfDay.toISOString(), end: endOfDay.toISOString() }
            )
            .then((items) => {
                let buy = 0, sell = 0;
                items.forEach((t) => {
                    if (t.buyOrSell === "Buy") buy += +t.quantity;
                    else sell += +t.quantity;
                });
                setData({ buy, sell, net: sell - buy });
            });
    }, []);

    return (
        <div className="summary-card-grid">
            <div className="summary-card-item">
                <span className="summary-card-label">Bought</span>
                <span className="summary-card-value text-danger">{data.buy} kg</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Sold</span>
                <span className="summary-card-value text-success">{data.sell} kg</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Net</span>
                <span className={`summary-card-value ${data.net >= 0 ? "text-success" : "text-danger"}`}>
                    {Math.abs(data.net)} kg
                </span>
            </div>
        </div>
    );
}